module.exports = __webpack_public_path__ + "img/MAOT_DB_Management_System_login.402a1fb9.svg";